import { Field, useField } from "react-final-form";
import styles from "./BusinessUpdateOtherField.module.scss";
import MeritoRadioButton from "../../../Finance/components/RadioButton/MeritoRadioButton";
import { directorSelectOptionValidation } from "../../../Underwriting/Director/directorHelper";
import OutlinedFormInput from "../../../Finance/components/OutlinedFormInput/OutlinedFormInput";
import { onBlurFormatNumber, parseNumberForDB } from "../../../../components/functions/utilities";
import MultiTagInputField from "../../../Finance/components/MultiTagInputField/MultiTagInputField";

type Props = {
  rootFieldName?: string;
  fieldType: "textfield" | "numberfield" | "textfieldwithchip";
  fieldName: string;
  fieldLabel: string;
  conditionField: boolean;
  radioButtonLabel?: string;
  radioLabels?: { label: string; value: string }[];
  fieldPlaceholder: string;
  fieldErrorLabel: string;
  monthYear: string;
  fieldSubText?: string;
}


const BusinessUdpateOtherFields = ({ rootFieldName, fieldType, fieldName, conditionField, radioButtonLabel, radioLabels, fieldPlaceholder, fieldErrorLabel, monthYear, fieldSubText, fieldLabel }: Props) => {

  const { input: { value: conditionFieldValue } } = useField(`${rootFieldName}.${monthYear}.isValid`, { subscription: { value: true } });

  const getTextFieldWithChip = () => {
    return (
      <Field name={`${rootFieldName}.${monthYear}.${fieldName}`} validate={(values) => {
        return (!values?.length ? fieldErrorLabel : undefined)
      }}>
        {(props) => (
          <MultiTagInputField
            fieldProps={props}
            fieldLabel={fieldLabel}
            fieldPlaceholder={fieldPlaceholder}
          />
        )
        }
      </Field>
    )
  }

  const getTextField = () => {
    return (
      <Field name={`${rootFieldName}.${monthYear}.${fieldName}`} validate={(values) => {
        if (!values) {
          return `${fieldErrorLabel}`;
        }
        return ''
      }}>
        {(props) => (
          <OutlinedFormInput
            {...props.input}
            label={fieldLabel}
            fieldType='lg'
            placeholder={fieldPlaceholder}
            name={props.input.name}
            value={props.input.value}
            onChange={props.input.onChange}
            error={props.meta.error}
            touched={props.meta.touched}
          />
        )}
      </Field>
    )
  }

  const getNumberField = () => {
    return (
      <Field name={`${rootFieldName}.${monthYear}.${fieldName}`} validate={(values) => {
        if (!values) {
          return `${fieldErrorLabel}`;
        }
        return ''
      }}>
        {(props) => (
          <div className={styles.fieldContainer}>
            <OutlinedFormInput
              {...props.input}
              textFieldType='outlined'
              fieldType='lg'
              showBorder={false}
              placeholder={'10,00,000'}
              showPlaceholder={false}
              inpuType='number'
              label={fieldLabel}
              // containerStyles={{ padding: "0" }}
              name={props.input.name}
              value={props.input.value}
              onChange={(e) => {
                const numericValue = parseNumberForDB(e.target.value, false);
                props.input.onChange(numericValue);
              }}
              onBlur={(e) => {

                const value = props.input.value;
                const formattedValue = onBlurFormatNumber(value, 0);
                props.input.onChange(formattedValue);
                // console.log('inputValue', value)
                props.input.onBlur(e);
              }}
              unitPlaceHolder='₹'
              error={props.meta.error}
              touched={props.meta.touched}
              isCurrency={true}
              maxLength={10}
            />

            {fieldSubText ?
              <div className={styles.subText}>
                {fieldSubText}
              </div> : null}
          </div>
        )}
      </Field>
    )
  }

  const getField = () => {
    switch (fieldType) {
      case "textfield":
        return getTextField();
      case "textfieldwithchip":
        return getTextFieldWithChip();
      case "numberfield":
        return getNumberField();
      default:
        return null;
    }
  }

  return (
    <>
      <div className={styles.fieldsContainer}>
        {conditionField ? <Field name={`${rootFieldName}.${monthYear}.isValid`} validate={(values) => directorSelectOptionValidation(values)}>
          {(props) => (
            <MeritoRadioButton
              {...props.input}
              label={radioButtonLabel}
              radioLabels={radioLabels}
              name={props.input.name}
              value={props.input.value}
              onChange={props.input.onChange}
              error={props.meta.error}
              touched={props.meta.touched}
              isLabelBold={true}
              size="md2"
            />
          )}
        </Field> : null}

        {conditionField ?
          conditionFieldValue == "yes" ?
            getField()
            : null
          :
          getField()
        }

      </div>
    </>
  );
}

export default BusinessUdpateOtherFields;